import React from 'react';

import Space from 'components/generic/Space.component';
import STAFF_NAME from 'constants/staff/name.const';
import asArray from 'utils/arrays/asArray.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import asObject from 'utils/objects/asObject.util';
import isFullArray from 'utils/predicates/array/isFullArray.util';
import createNodeKey from 'utils/react/createNodeKey.util';

// FIXME: component should not depend upon where it is put
const IS_OUTSIDE_CASHUP = fromAnyToBool(document.location.href.indexOf('cashup') <= 0);

const byValidStylist = ({ has_column: hasColumn, serves_as_waitlist: waitlist, status }) =>
  status !== 'deleted' && hasColumn && waitlist !== true;

// TODO: make this component a functional one
// eslint-disable-next-line react/prefer-stateless-function
class StylistTypeDropdown extends React.Component {
  render() {
    const { stylists: stylistsFromProps, onSelectStylist, openDropdownStylist, isStylistOpen } = this.props;

    const stylists = IS_OUTSIDE_CASHUP ? asArray(stylistsFromProps) : asArray(stylistsFromProps).filter(byValidStylist);

    const hasStylists = isFullArray(stylists);

    if (hasStylists && stylists.indexOf(STAFF_NAME.all) < 0) {
      stylists.unshift(STAFF_NAME.self);
      stylists.unshift(STAFF_NAME.employed);
      stylists.unshift(STAFF_NAME.all);
    }

    return (
      <div data-bem="StylistTypeDropdown" role="button" tabIndex="0">
        {isStylistOpen && (
          <div className="select-box--items">
            <span className="label">Show takings from</span>
            {hasStylists && (
              <>
                {stylists.map((stylist, index) => {
                  const { name } = asObject(stylist);

                  const handleClick = () => {
                    onSelectStylist(stylist);
                    openDropdownStylist();
                  };

                  return (
                    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                    <div key={createNodeKey({ index, tag: name })} className="select-by" onClick={handleClick}>
                      {IS_OUTSIDE_CASHUP &&
                        name &&
                        `${name} ${stylist.is_self_employed ? '(self-employed)' : '(employed)'}`}
                      {IS_OUTSIDE_CASHUP && !name && `${stylist}`}

                      {!IS_OUTSIDE_CASHUP && (
                        <>
                          <Space>{stylist.user_name ? stylist.user_name : stylist}</Space>
                          <Space>{stylist.is_self_employed ? '(self-employed)' : <span>(employed)</span>}</Space>
                        </>
                      )}
                    </div>
                  );
                })}
              </>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default StylistTypeDropdown;
